// Canonical body map regions. Slugs are durable in stored data and must
// match the backend list in flexcoa-api/assessment_builder/constants/body_regions.py.

export const VIEW_ANTERIOR = 'anterior';
export const VIEW_POSTERIOR = 'posterior';

export const BODY_REGIONS = [
  // Anterior view (29 regions)
  { slug: 'face', label: 'Face', view: VIEW_ANTERIOR },
  { slug: 'front_neck', label: 'Front of Neck', view: VIEW_ANTERIOR },
  { slug: 'front_left_shoulder', label: 'Front Left Shoulder', view: VIEW_ANTERIOR },
  { slug: 'front_right_shoulder', label: 'Front Right Shoulder', view: VIEW_ANTERIOR },
  { slug: 'chest', label: 'Chest', view: VIEW_ANTERIOR },
  { slug: 'abdomen', label: 'Abdomen', view: VIEW_ANTERIOR },
  { slug: 'pelvis', label: 'Pelvis', view: VIEW_ANTERIOR },
  { slug: 'left_hip', label: 'Left Hip', view: VIEW_ANTERIOR },
  { slug: 'right_hip', label: 'Right Hip', view: VIEW_ANTERIOR },
  { slug: 'front_left_upper_arm', label: 'Front Left Upper Arm', view: VIEW_ANTERIOR },
  { slug: 'front_right_upper_arm', label: 'Front Right Upper Arm', view: VIEW_ANTERIOR },
  { slug: 'front_left_elbow', label: 'Front Left Elbow', view: VIEW_ANTERIOR },
  { slug: 'front_right_elbow', label: 'Front Right Elbow', view: VIEW_ANTERIOR },
  { slug: 'front_left_lower_arm', label: 'Front Left Lower Arm', view: VIEW_ANTERIOR },
  { slug: 'front_right_lower_arm', label: 'Front Right Lower Arm', view: VIEW_ANTERIOR },
  { slug: 'front_left_wrist', label: 'Front Left Wrist', view: VIEW_ANTERIOR },
  { slug: 'front_right_wrist', label: 'Front Right Wrist', view: VIEW_ANTERIOR },
  { slug: 'front_left_hand', label: 'Palm of Left Hand', view: VIEW_ANTERIOR },
  { slug: 'front_right_hand', label: 'Palm of Right Hand', view: VIEW_ANTERIOR },
  { slug: 'front_left_thigh', label: 'Front Left Thigh', view: VIEW_ANTERIOR },
  { slug: 'front_right_thigh', label: 'Front Right Thigh', view: VIEW_ANTERIOR },
  { slug: 'front_left_knee', label: 'Front Left Knee', view: VIEW_ANTERIOR },
  { slug: 'front_right_knee', label: 'Front Right Knee', view: VIEW_ANTERIOR },
  { slug: 'front_left_shin', label: 'Front Left Shin', view: VIEW_ANTERIOR },
  { slug: 'front_right_shin', label: 'Front Right Shin', view: VIEW_ANTERIOR },
  { slug: 'front_left_ankle', label: 'Front Left Ankle', view: VIEW_ANTERIOR },
  { slug: 'front_right_ankle', label: 'Front Right Ankle', view: VIEW_ANTERIOR },
  { slug: 'front_left_foot', label: 'Top of Left Foot', view: VIEW_ANTERIOR },
  { slug: 'front_right_foot', label: 'Top of Right Foot', view: VIEW_ANTERIOR },

  // Posterior view (28 regions)
  { slug: 'back_head', label: 'Back of Head', view: VIEW_POSTERIOR },
  { slug: 'back_neck', label: 'Back of Neck', view: VIEW_POSTERIOR },
  { slug: 'back_left_shoulder', label: 'Back Left Shoulder', view: VIEW_POSTERIOR },
  { slug: 'back_right_shoulder', label: 'Back Right Shoulder', view: VIEW_POSTERIOR },
  { slug: 'upper_back', label: 'Upper Back', view: VIEW_POSTERIOR },
  { slug: 'lower_back', label: 'Lower Back', view: VIEW_POSTERIOR },
  { slug: 'left_buttock', label: 'Left Buttock', view: VIEW_POSTERIOR },
  { slug: 'right_buttock', label: 'Right Buttock', view: VIEW_POSTERIOR },
  { slug: 'back_left_upper_arm', label: 'Back Left Upper Arm', view: VIEW_POSTERIOR },
  { slug: 'back_right_upper_arm', label: 'Back Right Upper Arm', view: VIEW_POSTERIOR },
  { slug: 'back_left_elbow', label: 'Back Left Elbow', view: VIEW_POSTERIOR },
  { slug: 'back_right_elbow', label: 'Back Right Elbow', view: VIEW_POSTERIOR },
  { slug: 'back_left_lower_arm', label: 'Back Left Lower Arm', view: VIEW_POSTERIOR },
  { slug: 'back_right_lower_arm', label: 'Back Right Lower Arm', view: VIEW_POSTERIOR },
  { slug: 'back_left_wrist', label: 'Back Left Wrist', view: VIEW_POSTERIOR },
  { slug: 'back_right_wrist', label: 'Back Right Wrist', view: VIEW_POSTERIOR },
  { slug: 'back_left_hand', label: 'Back of Left Hand', view: VIEW_POSTERIOR },
  { slug: 'back_right_hand', label: 'Back of Right Hand', view: VIEW_POSTERIOR },
  { slug: 'back_left_thigh', label: 'Back Left Thigh', view: VIEW_POSTERIOR },
  { slug: 'back_right_thigh', label: 'Back Right Thigh', view: VIEW_POSTERIOR },
  { slug: 'back_left_knee', label: 'Back Left Knee', view: VIEW_POSTERIOR },
  { slug: 'back_right_knee', label: 'Back Right Knee', view: VIEW_POSTERIOR },
  { slug: 'back_left_calf', label: 'Back Left Calf', view: VIEW_POSTERIOR },
  { slug: 'back_right_calf', label: 'Back Right Calf', view: VIEW_POSTERIOR },
  { slug: 'back_left_ankle', label: 'Back Left Ankle', view: VIEW_POSTERIOR },
  { slug: 'back_right_ankle', label: 'Back Right Ankle', view: VIEW_POSTERIOR },
  { slug: 'back_left_foot', label: 'Sole of Left Foot', view: VIEW_POSTERIOR },
  { slug: 'back_right_foot', label: 'Sole of Right Foot', view: VIEW_POSTERIOR },
];

export const BODY_REGION_BY_SLUG = Object.fromEntries(
  BODY_REGIONS.map((r) => [r.slug, r]),
);

export const getRegionLabel = (slug) => BODY_REGION_BY_SLUG[slug]?.label ?? slug;
